import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import '@fontsource/inter';
import AppRoute from './components/AppRoute';

const root = createRoot(document.getElementById('root') as HTMLElement)
if (import.meta.env.MODE === 'test') {
  void import('@/__mocks__/browser')
    .then(({ worker }) => {
      void worker.start()
    })
    .then(() => {
      root.render(
        <StrictMode>
          <AppRoute />
        </StrictMode>,
      )
    })
} else {
  root.render(
    <StrictMode>
      <AppRoute />
    </StrictMode>,
  )
}

// Uncomment if you want to see the Lighthouse report in the console
// import reportWebVitals from './reportWebVitals'
// reportWebVitals(console.log)
